import type { AppResponse } from '@app/common';

import { env } from '../config/env';
import { supabase } from '../lib/supabase';

// Backend sendFailure wraps errors as: { success: false, errors: { message, error, ... } }
// This helper extracts the best human-readable message from any error shape.
function extractErrorMessage(json: AppResponse<unknown>, httpStatus: number): string {
  const errors = (json as unknown as Record<string, unknown>).errors;
  if (errors && typeof errors === 'object') {
    const e = errors as Record<string, unknown>;
    if (typeof e.message === 'string' && e.message) return e.message;
    if (typeof e.error === 'string' && e.error) return e.error;
  }
  if (typeof json.message === 'string' && json.message) return json.message;
  if (typeof json.error === 'string' && json.error) return json.error;
  return `Request failed with status ${httpStatus}`;
}

export const apiFetch = async <T>(path: string, options?: RequestInit): Promise<T> => {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;

  const response = await fetch(`${env.apiBaseUrl}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...options,
  });

  const json: AppResponse<T> = await response.json();

  if (!response.ok || !json.success) {
    throw new Error(extractErrorMessage(json, response.status));
  }

  return json.data as T;
};
